// extracted by mini-css-extract-plugin
export default {"container":"ar-z","brandName":"br-z","productName":"cr-z","productNamePdpEnhancements":"dr-z","breakLongProductName":"er-z"};